// The "→" character in Wotfard doesn't look good; it’s thin and pointy. Instead, we’ll use the system-ui one, which looks nice and symmetrical.
import { styled } from '@linaria/react';
import * as React from 'react';

interface Props extends React.HTMLAttributes<HTMLSpanElement> {
  direction: 'up' | 'down' | 'left' | 'right';
}

const CHARS = {
  up: '↑',
  down: '↓',
  left: '←',
  right: '→',
};

function ArrowChar({ direction, ...delegated }: Props) {
  return <Wrapper {...delegated}>{CHARS[direction]}</Wrapper>;
}

const Wrapper = styled.span`
  font-size: 0.925em;
  font-weight: 600;
  font-family: system-ui, monospace;
`;

export default ArrowChar;
